module.exports = __webpack_public_path__ + "static/media/S1-16-Noctrobazz-cod16.d3868aae.png";